module.exports = __webpack_public_path__ + "img/24.98809d74.jpg";